import { sendJsonRequest } from "./utils";

export default function moveToSections(postId, sections) {
    const data = {
        sections,
        post_id: postId,
        action: "move_post_to_sections",
    };

    return sendJsonRequest("/core/roar/post_actions", "POST", data);
}
